export const LOCALSTORAGE_COPY_KEY = 'copied_fields';
